/* import __COLOCATED_TEMPLATE__ from './metrics.hbs'; */
import Component from '@glimmer/component';
import ENV from 'sh-www/config/environment';

class Metrics extends Component {
  get metrics() {
    const statistics = this.args.companyStatistics;

    return [
      {
        metricTitle: 'Total in-network creators',
        metricNumber: statistics?.totalInNetworkCreators.toLocaleString('en-US') ?? '-',
        metricTooltipIcon: 'help',
        metricTooltipLink: `https://${ENV.supportDomain}/en/articles/8392550-your-creator-network-and-network-size`
      },
      {
        metricTitle: 'In-network projects',
        metricNumber: statistics?.inNetworkProjects.toLocaleString('en-US') ?? '-'
      },
      {
        metricTitle: 'In-network services',
        metricNumber: statistics?.inNetworkServices.toLocaleString('en-US') ?? '-'
      },
    ];
  }
}

export default Metrics;
